// frontend/src/StoreLocator/SpecialHours.jsx — dated rules for all stores, a tag or one store.
import React, { useState } from 'react';
import { Select, TextField } from '@shopify/polaris';
import { StatusPill } from '../ui';
import { Alert, useList } from '../GiftCards/common';
import { slApi } from './apiClient';
import ScopePicker from './ScopePicker';
import DateField from './DateField';
import { clock, scopeText, span } from './common';

const TIMES = [];
for (let m = 5 * 60; m < 24 * 60; m += 15) { const hh = String(Math.floor(m / 60)).padStart(2, '0'); const mm = String(m % 60).padStart(2, '0'); TIMES.push({ value: `${hh}:${mm}`, label: clock(`${hh}:${mm}`) }); }
const blank = () => ({ starts_on: '', ends_on: '', status: 'closed', open: '09:00', close: '17:00', note: '', scope: 'all', tag: '', location_id: null });

export default function SpecialHours({ ctx }) {
  const { data, error, reload } = useList(() => slApi.rules(), []);
  const [form, setForm] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const edit = (r) => setForm(r ? { ...r, ends_on: r.ends_on || r.starts_on, open: r.open || '09:00', close: r.close || '17:00', id: r.id } : blank());
  const save = async () => {
    setBusy(true); setErr('');
    const body = { ...form, ends_on: form.ends_on || form.starts_on };
    try { const r = form.id ? await slApi.updateRule(form.id, body) : await slApi.addRule(body); setForm(null); reload(); ctx.notify(r.publish_id ? 'Saved; pushing the affected stores to the sites now' : 'Saved'); } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  const remove = async (r) => { if (!window.confirm(`Remove the special hours for ${scopeText(r)}, ${span(r.starts_on, r.ends_on)}?`)) return; try { await slApi.removeRule(r.id); reload(); ctx.notify('Removed; pushing the affected stores to the sites now'); } catch (e) { ctx.notify(e.message); } };
  const rules = (data && data.rules) || [];
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="uh-card">
      <div className="uh-ia-tbar">
        <span className="uh-ia-hint">A rule applies to all stores, every store with a tag, or one store; on a date the most specific rule wins. Published with each location: the store page shows the notice up to 14 days ahead and uses the hours on the day.</span>
        <span className="uh-sp" /><button type="button" className="uh-btn primary" onClick={() => edit(null)}>Add rule</button>
      </div>
      <div className="uh-card-b">
        <Alert>{error}</Alert>
        {form && (
          <div className="uh-form-card uh-sl-form">
            <div className="uh-ia-frow">
              <DateField label="From" value={form.starts_on} onChange={(v) => setForm({ ...form, starts_on: v, ends_on: form.ends_on && form.ends_on >= v ? form.ends_on : v })} />
              <DateField label="To" value={form.ends_on} min={form.starts_on} onChange={(v) => setForm({ ...form, ends_on: v })} />
              <ScopePicker value={form} onChange={setForm} tags={ctx.meta && ctx.meta.tags} />
              <Select label="Hours" value={form.status} onChange={(v) => setForm({ ...form, status: v })} options={[{ value: 'closed', label: 'Closed' }, { value: 'open', label: 'Open with these hours' }]} />
              {form.status === 'open' && <Select label="Opens" value={form.open} onChange={(v) => setForm({ ...form, open: v })} options={TIMES} />}
              {form.status === 'open' && <Select label="Closes" value={form.close} onChange={(v) => setForm({ ...form, close: v })} options={TIMES} />}
              <div className="uh-span2"><TextField label="Notice shown on the page" value={form.note} placeholder="Closed for Thanksgiving." autoComplete="off" onChange={(v) => setForm({ ...form, note: v })} /></div>
            </div>
            {err && <div className="uh-ia-bad">{err}</div>}
            <div className="uh-ia-row"><button type="button" className="uh-btn primary" disabled={busy} onClick={save}>{form.id ? 'Save' : 'Add'}</button><button type="button" className="uh-btn" disabled={busy} onClick={() => setForm(null)}>Cancel</button></div>
          </div>
        )}
        <div className="uh-tscroll"><table className="uh-tbl">
          <thead><tr><th>Dates</th><th>Applies to</th><th>Hours</th><th>Notice</th><th>Added by</th><th /></tr></thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id} className={r.ends_on < today ? 'uh-ia-old' : ''}>
                <td>{span(r.starts_on, r.ends_on)}</td><td>{scopeText(r)}</td>
                <td>{r.status === 'closed' ? <StatusPill tone="can">Closed</StatusPill> : `${clock(r.open)} – ${clock(r.close)}`}</td>
                <td>{r.note}</td><td>{r.created_by_name}</td>
                <td className="uh-ia-nowrap"><button type="button" className="uh-btn slim" onClick={() => edit(r)}>Edit</button> <button type="button" className="uh-btn slim" onClick={() => remove(r)}>Remove</button></td>
              </tr>
            ))}
            {data && rules.length === 0 && <tr><td colSpan={6} className="uh-empty">No special hours yet.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
